<app-default-layout>
    <div class="text-center">
        <h1 class="text-error">404</h1>
        <h3 class="mt-3 mb-2">Página no encontrada</h3>
        <p class="text-muted mb-3">La página que busca no existe, probablemente la url que ha escrito en su navegador no pertenece a ninguna sección de la plataforma. Por favor pruebe con otra dirección.</p>
        <a routerLink="/" class="btn btn-primary waves-effect waves-light"><i class="mdi mdi-login" [ngClass]="{'mdi-home-outline': loggedInUser !== null, 'mdi-login': loggedInUser === null}"></i> {{buttonMessage}}</a>
    </div>

</app-default-layout>
